// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item_dBiZT {
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  column-gap: var(--size-padSmall);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-operating-hours/lib/DailyHoursListEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,gCAAgC;AAClC","sourcesContent":[".item {\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr auto;\n  column-gap: var(--size-padSmall);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `item_dBiZT`
};
export default ___CSS_LOADER_EXPORT___;
